// import arModel from './ModelData/AR';
// import boModel from './ModelData/BO';
// import diModel from './ModelData/DI';
import ekModel from './ModelDataTS/EK';
// import gaModel from './ModelData/GA';
// import kjModel from './ModelData/KJ';
// import krModel from './ModelData/KR';
// import laModel from './ModelData/LA';
import lrModel from './ModelDataTS/LR';
// import muModel from './ModelData/MU';
// import ofModel from './ModelData/OF';
import opModel from './ModelDataTS/OP';
// import puModel from './ModelData/PU';
import sysModel from './ModelDataTS/SYS';
// import tiModel from './ModelData/TI';

import { IClientAvenyModelType } from '../Types/ClientModelTypes';

const clientAvenyModel: IClientAvenyModelType = {
  // AR: arModel,
  // BO: boModel,
  // DI: diModel,
  EK: ekModel,
  // GA: gaModel,
  // KJ: kjModel,
  // KR: krModel,
  // LA: laModel,
  LR: lrModel,
  // MU: muModel,
  // OF: ofModel,
  OP: opModel,
  // PU: puModel,
  SYS: sysModel,
  // TI: tiModel,
};

export default clientAvenyModel;
